import { Outside } from '@cian/ui-kit';
import * as React from 'react';

import { throttle500 } from '../../helpers';
import { CoworkingProfitBannerService } from '../../services';

import { CoworkingProfitBannerView } from '../CoworkingProfitBannerView';

import { CoworkingProfitBannerPops, CoworkingProfitBannerState } from './types';

export class CoworkingProfitBannerControlled extends React.PureComponent<
  CoworkingProfitBannerPops,
  CoworkingProfitBannerState
> {
  private readonly coworkingProfitBannerService: CoworkingProfitBannerService;
  private readonly buttonRef: React.RefObject<HTMLButtonElement>;

  public constructor(props: CoworkingProfitBannerPops) {
    super(props);

    const { setIsHoverBehavior } = props;

    this.state = {
      tooltipVisible: false,
    };

    this.buttonRef = React.createRef<HTMLButtonElement>();

    this.coworkingProfitBannerService = new CoworkingProfitBannerService(() => setIsHoverBehavior(true));
  }

  public componentDidMount(): void {
    const { setIsHoverBehavior } = this.props;

    if (CoworkingProfitBannerService.isCoworkingProfitWasShown) {
      setIsHoverBehavior(true);
    } else {
      if (CoworkingProfitBannerService.isElementInViewport(this.buttonRef)) {
        this.componentInViewPortMountActions();
      } else {
        this.componentOutViewPortMountActions();
      }
    }
  }

  public componentWillUnmount(): void {
    this.coworkingProfitBannerService.removeAllListeners();
  }

  public render(): React.ReactNode {
    const { tooltipVisible } = this.state;

    return (
      <Outside active insideRefs={[]} onOutside={this.onTooltipClose}>
        <CoworkingProfitBannerView onOpen={this.onTooltipOpen} open={tooltipVisible} ref={this.buttonRef} />
      </Outside>
    );
  }

  private readonly setTooltipVisibility = (tooltipVisible: boolean, callback?: VoidFunction) => () =>
    this.setState({ tooltipVisible }, callback);

  /**
   * @method componentInViewPortMountActions
   * @private
   * @description данный метод вызывается только при монтировании компонента, если баннер не был ни разу показан
   * и баннер находится в области видимости окна браузера
   */
  private componentInViewPortMountActions(): void {
    this.coworkingProfitBannerService.coworkingProfitBannerWasShown();

    this.onTooltipOpen();
  }

  /**
   * @method componentOutViewPortMountActions
   * @private
   * @description данный метод вызывается только при монтировании компонента, если баннер не был ни разу показан
   * и баннер не находится в поле видимости окна браузера
   */
  private componentOutViewPortMountActions(): void {
    const onScroll = throttle500(() => {
      if (
        !CoworkingProfitBannerService.isCoworkingProfitWasShown &&
        CoworkingProfitBannerService.isElementInViewport(this.buttonRef)
      ) {
        this.coworkingProfitBannerService.coworkingProfitBannerWasShown();

        this.onTooltipOpen();
      }
    });

    this.coworkingProfitBannerService.addListener(onScroll);
  }

  private readonly onScrollAfterShowTooltip = throttle500((): void => {
    if (!CoworkingProfitBannerService.isElementInViewport(this.buttonRef)) {
      this.onTooltipClose();
    }
  });

  private readonly onTooltipClose = (): void => {
    const { setIsHoverBehavior } = this.props;

    this.coworkingProfitBannerService.removeListener(this.onScrollAfterShowTooltip);

    setIsHoverBehavior(true);

    this.setTooltipVisibility(false)();
  };

  private readonly onTooltipOpen = (): void => {
    this.setTooltipVisibility(true)();

    this.coworkingProfitBannerService.addListener(this.onScrollAfterShowTooltip);
  };
}
